export const colors = {
    black: '#000000',
    black2: '#999999',
    blackAlpha12: '#1f1f1f1f',
    blackAlpha14: '#24242424',
    blackAlpha20: '#33333333',
    blackAlpha25: '#40404040',
    blackAlpha87: '#000000de',
    blue2: '#405766',
    blue3: '#2d70b3',
    blueGrayAlpha30: '#a9bfcddf',
    borderBlack: 'rgba(33, 33, 33, 0.08)',
    breezeBlue: '#9bd2f2',
    darkBlueAlpha10: '#0544661A',
    coralPink: '#fa6970',
    darkBlueAlpha20: '#05446633',
    darkBlueAlpha30: '#0544664d',
    darkBlueAlpha35: '#05446659',
    darkBlueAlpha43: '#0544666e',
    darkGray: '#333333',
    darkGrayAlpha08: '#21212114',
    darkSlateAlpha30: '#4157624d',
    dawnSkyBlue: '#adbff5',
    dustyBlue: '#9aaab5',
    dimGray: '#666666',
    dodgerBlue: '#138efd',
    electricBlue: '#4895f6',
    errorRed: '#f44336',
    gradientWhite: 'linear-gradient(110deg, #ffffff, #ffffff)',
    gray1: '#333333',
    gray2: '#edeff8',
    gray3: '#828282',
    gray4: '#bdbdbd',
    gray5: '#e0e0e0;',
    grayC4: '#c4c4c4',
    green: 'linear-gradient(100deg, #35d46a, #33d489)',
    headingGray: '#828282',
    lightBlue: '#d7e2ff',
    lightBlue2: '#edeefe',
    lightGray: '#f6f7fb',
    lightGrayBlue: '#cccfd9',
    lightSteelBlue: '#9ec0cc',
    mediumGray: '#bdbdbd',
    midGray: '#e0e0e0',
    mintyGreen: '#2cb56a',
    paleRed: '#EF766D',
    pasterBlue: '#9dc1f2',
    powderBlue: '#8ebbde',
    red: '#ff0000',
    neonSkyBlue: '#2eb1ff',
    paleSlate: '#cccfd9',
    sailBlue: '#3269f5',
    sailYellow: '#ffd746',
    sailPlusYellowTitle: '#E7B500',
    sailPlusPink: '#ff8787',
    silver: '#cccccc',
    silverMist: '#eeeeee',
    softSilver: '#e9eef2',
    steelBlueGray: '#445664',
    turquoise: '#1cdfb9',
    vividSkyBlue: '#1e9dfd',
    white: '#ffffff',
    // Color Codeそのままで変数化
    '00000000': '#00000000',
    '000000': '#000000',
    '111111': '#111111',
    '21212114': '#21212114',
    '00000026': '#00000026',
    '0000004d': '#0000004d',
    '0544661a': '#0544661a',
    '0544664d': '#0544664d',
    '05446659': '#05446659',
    '0544666e': '#0544666e',
    '05446680': '#05446680',
    '065580bf': '#065580bf',
    '0d7df2': '#0d7df2',
    '138efd': '#138efd',
    '2eb1ff': '#2eb1ff',
    '3269f5': '#3269f5',
    '3269f580': '#3269f580',
    '333333': '#333333',
    '35d46a': '#35d46a',
    '33d489': '#33d489',
    '405766': '#405766',
    '4067ec': '#4067ec',
    '415765': '#415765',
    '4a709c': '#4a709c',
    '4f4f4f': '#4f4f4f',
    '666666': '#666666',
    '78a2cb': '#78a2cb',
    '828282': '#828282',
    '8394a0': '#8394a0',
    '8ad043': '#8AD043',
    '999999': '#999999',
    '9eb0bb': '#9eb0bb',
    '9ec0cc': '#9ec0cc',
    aad3f2: '#aad3f2',
    bdbdbd: '#bdbdbd',
    c4c4c4: '#c4c4c4',
    c9e0f2: '#c9e0f2',
    cccccc: '#cccccc',
    cccfd9: '#cccfd9',
    cce5ef: '#cce5ef',
    d1dee5: '#d1dee5',
    d9d9d9: '#d9d9d9',
    d9d9d966: '#d9d9d966',
    dceeff: '#dceeff',
    d7e2ff: '#d7e2ff',
    e0e0e0: '#e0e0e0',
    e4ebf5: '#e4ebf5',
    e9eef2: '#e9eef2',
    eeeeee: '#eeeeee',
    f44336: '#f44336',
    f6f7fb: '#f6f7fb',
    f8d862: '#f8d862',
    ff0000: '#ff0000',
    ff676e: '#ff676e',
    ff8787: '#ff8787',
    ffd746: '#ffd746',
    ff6169: '#ff6169',
    ff6e7a: '#ff6e7a',
    ffffff: '#ffffff',
};
